import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { isEmpty } from "lodash";
import CommonPasswordInput from "../../common/component/commonPassword";
import useValidation from "../../common/utils/validationRules";
import CommonRadioGroup from "../../common/component/commonRadioGroup";
import CommonButton from "../../common/component/commonButton";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useToast } from "../../common/component/Toast";
import logoImg from "../../assests/images/sifo-lofo.png";
import {
  sendOtp,
  updatePassword,
} from "../../service/action/actioncreator/LoginAction/LoginAction";
import CommonLoader from "../../common/component/commonLoader";
import { useLoader } from "../../common/component/LoaderProvider";
import { encryptUsingAES256 } from "../../common/utils/index";
import { useTranslation } from "react-i18next";

const ChangePassword = () => {
  const [validationFlag, setValidationFlag] = useState(false);
  const [notificationFlag, setNotificationFlag] = useState(false);
  const buttonRef = useRef();
  const whiteSpaceRegex = /^\s+|\s+$/g;
  const { showToast } = useToast();
  const { showLoader, hideLoader } = useLoader();
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();
  const [isOldPasswordErr, setIsOldPasswordErr] = useState(false);
  const [isErrors, setIsError] = useState("")
  const otpOptions = [
    { label: "SMS", value: "SMS" },
    { label: "Mail", value: "Mail" },
    { label: "App Twilio Authy", value: "App Twilio Authy" },
  ];
  const changePw = useSelector(
    (state) => state?.loginReducer?.changePasswordResponse
  );


  const navigate = useNavigate();
  const { validateField } = useValidation();

  const loginValue = useSelector((state) => state.commonReducer);
  const loginResponseData = useSelector(
    (state) => state.loginReducer.loginResponse
  );
  const loading = useSelector(
    (state) => state.loginReducer.changePasswordLoading
  );

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    watch,
  } = useForm();
  watch("oldPassword");
  watch("newPassword");
  watch("confirmPassword");
  watch("selectedOption");

  useEffect(() => {
    if (isEmpty(getValues("oldPassword"))) {
      setValue("newPassword", "");
      setValue("confirmPassword", "");
    }
    if (isEmpty(getValues("newPassword"))) {
      setValue("confirmPassword", "");
    }
  }, [
    getValues("oldPassword"),
    getValues("newPassword"),
    getValues("confirmPassword"),
  ]);
  const onSubmit = (data) => {

    if (validationFlag) {
      setIsError("text_unmatch_password")
    }


    var id = localStorage.getItem("userId");
    var navigateFlag = true;
    let flag = false;
    let removeItem = false;
    let changePwFirstAccess = true;

    var payloadOne = {
      userId: parseInt(id),
      authenticationFor: "Update password",
      AccessIdentifier: "validate",
      authenticationType: getValues("selectedOption") === "Mail" ? 1 : getValues("selectedOption") === "SMS" ? 2 : 1,
    };
    var headers = {
      UserId: parseInt(id),
      // OtpCode:675434,
      authenticationType: getValues("selectedOption") === "Mail" ? 1 : getValues("selectedOption") === "SMS" ? 2 : 1,
      AuthenticationFor: "Update Password",
      AccessIdentifier: "validate",
    };
    var payload = {
      userId: parseInt(id),
      oldPassword: encryptUsingAES256(getValues("oldPassword")?.trim()),
      password: encryptUsingAES256(getValues("newPassword")?.trim()),
    };
    let resetString="resetPassword"

    if (
      !isEmpty(getValues("oldPassword")) &&
      !isEmpty(getValues("newPassword")) &&
      !isEmpty(getValues("confirmPassword"))
    ) {
      if (
        getValues("newPassword")?.trim() != getValues("confirmPassword")?.trim()
      ) {
        setValidationFlag(true);
        // showToast('error',t('text_toast_danger'), `${t('text_unmatch_password')}`);
      } else {
        setValidationFlag(false)

        if (!isEmpty(getValues("oldPassword")) && !isEmpty(getValues("newPassword")) && !isEmpty(getValues("confirmPassword")) && !isEmpty(getValues("selectedOption"))) {
          localStorage.setItem(
            "oldpassword",
            encryptUsingAES256(getValues("oldPassword")?.trim())
          );
          localStorage.setItem(
            "password",
            encryptUsingAES256(getValues("newPassword")?.trim())
          );

          dispatch(
            updatePassword(
              payload,
              headers,
              navigate,
              showLoader,
              hideLoader,
              showToast,
              t,
              flag,
              setNotificationFlag,
              payloadOne,
              navigateFlag,
              changePwFirstAccess,
              setIsError,
              setIsOldPasswordErr,
              resetString
            )
          );
          localStorage.setItem("authenticationType", getValues("selectedOption") === "Mail" ? 1 : getValues("selectedOption") === "SMS" ? 2 : 1,)
          // dispatch(sendOtp(payload,navigate,showLoader,hideLoader,navigateFlag))
          // payload,headers,navigate,showLoader,hideLoader,flag,setNotificationFlag,payloadOne,navigateFlag
        }
      }
    }
  };

  const skipPasswordFn = () => {
    if (
      loginResponseData.data?.isFirstAccess === true &&
      loginResponseData.data?.isTempPassword === true
    ) {
      localStorage.setItem("authData", JSON.stringify(loginValue?.data?.token));
      // navigate("/dashboard");
      let roleData = localStorage.getItem('roleId')
      if (roleData === '1') {
        navigate('/qcadmin')
      } else {
        navigate('/dashboard')
      }

      showToast("success", "Successo", "Utente loggato con successo.");
    } else if (
      loginResponseData?.data?.isFirstAccess === false &&
      loginResponseData?.data?.isTempPassword === true
    ) {
      showToast(
        "warn",
        "Attenzione",
        "Si prega di cambiare la password. La tua password temporanea è valida solo per la prima volta."
      );
    }
  };
  const handleRemoveData = () => {
    setValue("newPassword", "");
    setValue("confirmPassword", "");
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      buttonRef.current.click();
    }
  };

  // Add event listener to the input
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);


  return (
    <div className="main-container sub-container pwd-btn">
      <div className="login-container">
        <div className="login-box text-center">
          <div className="display-flex">
            <img src={logoImg} alt="log-img" className="logo-img" />
          </div>
          <div className="login-form">
            <div className="mb-2">
              <CommonPasswordInput
                name="oldPassword"
                placeholder={t("placeholder_old_password")}
                register={register}
                errors={errors}
                validationFn={validateField}
                control={control}
                disabled={false}
                inputStyle={true}
              />
            </div>
            <div className="mt-2">
              <CommonPasswordInput
                name="newPassword"
                placeholder={t("placeholder_new_password")}
                register={register}
                errors={errors}
                validationFn={validateField}
                control={control}
                disabled={isEmpty(getValues("oldPassword"))}
                resErrorFlag={errors.newPassword ? true : false}
                inputStyle={true}
                handleRemoveData={handleRemoveData}
              />
            </div>
            <div className="mt-2">
              <CommonPasswordInput
                name="confirmPassword"
                placeholder={t("placeholder_retype_password")}
                register={register}
                errors={errors}
                validationFn={validateField}
                control={control}
                disabled={isEmpty(getValues("newPassword"))}
                inputStyle={true}
                resErrorFlag={errors.confirmPassword ? true : false}
                handleRemoveData={handleRemoveData}
              />
            </div>
            <p className="mt-2 ms-2 primary-text-color text-left">{`${t(
              "text_sms_variable"
            )}`}</p>
            <div className="radiogroups ms-2">
              <CommonRadioGroup
                name="selectedOption"
                options={otpOptions}
                control={control}
                errors={errors}
                register={register}
                validationFn={validateField}
              />
            </div>

            <div className="mt-2 d-flex justify-content-between me-3 ml-2">
              <CommonButton
                label={t("text_button_cancel")}
                className=" btn btn-cancel input-style-common btn-cancel-style btn-width btn-padding primary-text-color"
                variant="cancel"
                type="button"
                onClick={() => navigate("/")}
                inputStyle={true}
              />
              <CommonButton
                label={t("text_button_send")}
                disabled={isEmpty(
                  getValues("oldPassword") &&
                  getValues("newPassword") &&
                  getValues("confirmPassword")
                )}
                onClick={handleSubmit(onSubmit)}
                buttonRef={buttonRef}
                className="ms-4 btn btn-success btn-padding btn-width input-style-common text-white ms-2"
                type="submit"
                variant="success"
                inputStyle={true}
              />
            </div>

            <div className="mt-5">
              <hr />
              {errors.oldPassword && (
                <div className="p-error">{errors.oldPassword.message}</div>
              )}
              {errors.newPassword && (
                <div className="p-error">{errors.newPassword.message}</div>
              )}
              {errors.confirmPassword && (
                <div className="p-error">{errors.confirmPassword.message}</div>
              )}
              {(validationFlag || isOldPasswordErr) && (
                <div className="p-error">{t(isErrors)}</div>
              )}

              {isEmpty(errors) && !validationFlag && !isOldPasswordErr && (
                <>
                  <div className="fw-bold mt-1 custom-text-break font-size-fs-6">
                    {t("text_password_changed")}
                  </div>
                </>
              )}
            </div>
          </div>
          <CommonLoader loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
